
import { Observable } from './druid/./druid/Observable';
import { _catch } from './druid/./druid/operator/catch';

Observable.prototype.catch = _catch;
Observable.prototype._catch = _catch;

declare module './druid/./druid/Observable' {
  interface Observable<T> {
    catch: typeof _catch;
    _catch: typeof _catch;
  }
}